<template>
  <a :href="`tel:${number}`">
    <template v-if="!$slots.default">
      {{ number }}
    </template>
    <slot/>
  </a>
</template>

<script>
export default {
  props: ['number'],
}
</script>

<style lang="scss">
@import '~style/variables';

</style>



// WEBPACK FOOTER //
// src/views/components/globals/Phone.vue